
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandR as ObiOwnShipNoCommandRElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-r.js';
 
 
 

 
 export const ObiOwnShipNoCommandR = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-r',
   elementClass: ObiOwnShipNoCommandRElement,
   events: {
     
   }
  });
 
 